module.exports = __webpack_public_path__ + "img/triangle.17707653.svg";